import { useCallback, useEffect, useMemo } from 'react';
export function useOverlayShortcut(onTrigger: () => void) {
  const isMac = useMemo(() => {
     const nav = navigator as Navigator & {
      userAgentData?: {
        platform?: string;
      };
    };

    if (nav.userAgentData && nav.userAgentData.platform) {
      return nav.userAgentData.platform.toLowerCase().includes('mac');
    }

    // Fallback for older browsers
    return navigator.userAgent.toLowerCase().includes('mac');
  }, []);
  
  // Memoize the handler
  const handleKeyDown = useCallback(
    (e: KeyboardEvent) => {
      const key = e.key.toLowerCase();

      // Mac: Ctrl+F
      if (isMac && e.ctrlKey && key === 'f') {
        e.preventDefault();
        onTrigger();
      }

      // Win/Linux: Alt+F
      if (!isMac && e.altKey && key === 'f') {
        e.preventDefault();
        onTrigger();
      }
    },
    [isMac, onTrigger]
  );
  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [handleKeyDown]);
  // useEffect(
  //   () => {
  //     // const isMac = isMacOS();
  //     const handleKeyDown = (e: KeyboardEvent) => {
  //       if (isMac) {
  //         if (e.ctrlKey && e.key.toLowerCase() === 'f') {
  //           e.preventDefault();
  //           onTrigger();
  //         }
  //       } else{
  //         if (e.altKey && e.key.toLowerCase() === 'f') {
  //           e.preventDefault();
  //           onTrigger();
  //         }
  //       }
  //     };

  //     window.addEventListener('keydown', handleKeyDown);
  //     return () => window.removeEventListener('keydown', handleKeyDown);
  //   },
  //   [onTrigger]
  // );
}
